export const load = () => ({
	title: "Increase Your Home's Resale Value with Indow Window Inserts",
	showTitle: true,
	breadcrumbs: false,
});
